/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {Row, Col, Box, Button, Pagination} from 'adminlte-2-react';
import Loader from '../../utils/Loader';
import {Alert} from '../../ui/alert';
import {submitSearchOnEnterPress, toTitleCase} from '../../utils/utils';
import {TextInput} from '../../utils/TextInput';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {useWindowSize} from '../../utils/useWindowSize';
import {ButtonWithLoading} from '../../utils/ButtonWithLoading';
import {Content} from '../../ui/Content';

function ListaCandidatosNormalizarView({
  history,
  topAlert,
  submitAlert,
  totalResults,
  activePage,
  pageSize,
  handlePage,
  candidatos,
  busquedaRapida,
  setBusquedaRapida,
  modelCandidatos,
}) {
  const {isMobile} = useWindowSize();

  const goToNextPage = page => {
    handlePage(page);
  };

  return (
    <Content title="Candidatos a actualizar" history={history}>
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      <Loader isLoading={modelCandidatos.loading}>
        <Row>
          <Col md="10" mdOffset="1">
            <Box title="Filtro">
              <Col md="3">
                <TextInput
                  label="Búsqueda rápida"
                  placeholder="Nombre, apellido, teléfono"
                  initialValue={busquedaRapida}
                  setValue={setBusquedaRapida}
                  onKeyDown={event =>
                    submitSearchOnEnterPress(event, () => handlePage(0))
                  }
                />
              </Col>
              <Col md="12">
                <div style={{float: 'right'}}>
                  <div style={{display: 'inline-block', marginRight: 10}}>
                    <Button
                      type="primary"
                      text="Filtrar"
                      onClick={() => handlePage(0)}
                    />
                  </div>
                </div>
              </Col>
            </Box>
          </Col>

          <Col md="10" mdOffset="1">
            <Box title="Lista">
              <div style={{display: 'block'}}>
                <span>Total: {totalResults}</span>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: isMobile ? 'column' : 'row',
                  justifyContent: 'space-between',
                }}>
                <div>
                  <Pagination
                    activePage={activePage}
                    pageSize={pageSize}
                    totalElements={totalResults}
                    onChange={goToNextPage}
                    labels={{
                      first: 'Primera',
                      last: 'Última',
                      previous: 'Anterior',
                      next: 'Siguiente',
                    }}
                  />
                </div>
              </div>

              <Loader isLoading={modelCandidatos.loading}>
                {candidatos && candidatos.length > 0 ? (
                  <Box noPadding={true} border={false} style={{borderTop: 0}}>
                    <div className="table-responsive">
                      <DataTable
                        lazy
                        pt={{
                          table: {
                            className: 'table table-hover',
                          },
                        }}
                        value={candidatos}
                        emptyMessage="No se encontraron registros">
                        <Column
                          field="nombreCompleto"
                          header="Nombre"
                          body={candidato =>
                            toTitleCase(candidato.nombreCompleto)
                          }></Column>
                        <Column
                          header="Acciones"
                          body={candidato => (
                            <ButtonWithLoading
                              text="Actualizar"
                              size="sm"
                              type="default"
                              submit={() =>
                                history.push(
                                  `/actualizarCandidato/${candidato.idNumerico}`,
                                )
                              }
                            />
                          )}></Column>
                      </DataTable>
                    </div>
                  </Box>
                ) : (
                  <h4>No se han encontrado candidatos a actualizar</h4>
                )}
              </Loader>
              <Pagination
                activePage={activePage}
                pageSize={pageSize}
                totalElements={totalResults}
                onChange={goToNextPage}
                labels={{
                  first: 'Primera',
                  last: 'Última',
                  previous: 'Anterior',
                  next: 'Siguiente',
                }}
              />
              <div>
                <span>Total: {totalResults}</span>
              </div>

              {submitAlert.text && (
                <Alert
                  title={submitAlert.title}
                  type={submitAlert.type}
                  text={submitAlert.text}
                  closable={submitAlert.closable}
                />
              )}
            </Box>
          </Col>
        </Row>
      </Loader>
    </Content>
  );
}

export {ListaCandidatosNormalizarView};
